module.exports = __webpack_public_path__ + "9b58e57d7a492272808cb266239b086b.svg";